import { render, staticRenderFns } from "./laboral_references_confirm.vue?vue&type=template&id=3c0884f0&"
import script from "./laboral_references_confirm.vue?vue&type=script&lang=js&"
export * from "./laboral_references_confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports